<template lang="pug">
footer.bg-dark.sticky-bottom.d-flex.justify-content-between.align-items-center.shadow-sm
  span.text-light Created by Tohru Ver. 0.4
  a(href="https://px.a8.net/svt/ejp?a8mat=2NT049+NTCZ6+1WP2+644DT" rel="nofollow")
    img(border="0" width="468" height="60" alt="" src="https://www26.a8.net/svt/bgt?aid=160916697040&wid=001&eno=01&mid=s00000008903001027000&mc=1")
  img(border="0" width="1" height="1" src="https://www10.a8.net/0.gif?a8mat=2NT049+NTCZ6+1WP2+644DT" alt="")
</template>

<script>
export default {}
</script>

<style lang="sass">
</style>
